var map = {
	"./git.png": "125b",
	"./posterminal.png": "5887",
	"./skyadminka.png": "5ffb",
	"./skycabinet.png": "ad09",
	"./skydash.png": "c6b2",
	"./skyknow.png": "c720",
	"./skysupport.png": "3a00",
	"./toolsy.png": "c1f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a700";